<div class="convenience-fee-box" style="background-color: #fffaf2;">
    <p class="convenience-fee-text" 
    style="background-color: #fffaf2;"
    [class.highlightTextRed]="isAmountGreaterThanUPILimit"
    >UPI transaction limit per day is ₹1 lakh as per RBI guidelines
    </p>
</div>

<div class="upi-payment-details-cont">
    <div class="pay-using-upi">
        <p>Pay using UPI ID</p>

    </div>

    <div class="find-upi">
        <p>How to find UPI ID ?
            <app-tooltip placement="bottom">
                <span class="find-upi-tooltip" trigger> Click here </span> <i class="fal fa-angle-down"></i>
                <div content class="tooltip-text">
                    <div class="row p-0 m-0">
                        <p class="col-xs-12">
                            In order to find out your UPI ID, Open your UPI registered application and navigate to
                            <strong>Home / Profile </strong> screen. Your UPI ID Will be displayed in a following format
                            “<strong>unique_ID@bank_name</strong> ”
                        </p>
                    </div>
                </div>
            </app-tooltip>
        </p>
    </div>

    <form [formGroup]="upiPaymentForm">
        <div class="row">
            <mat-form-field class="col-xs-12 upi-wrapper">
                <input class="upi-id" type="email" matInput formControlName="vpa" name="vpa" placeholder="Enter the UPI ID"
                    [(ngModel)]="paymentRequest.paymentDetails.upiDetails.vpa" (ngModelChange)="onVPAChange()">
                <mat-error class="error-message">
                    {{ getErrorMessage(upiPaymentForm.controls.vpa) }}
                </mat-error>
            </mat-form-field>
        </div>
    </form>

    <div class="row upi-step">

        <div class="col-sm-4 px-0">
            <div class="col-xs-2 col-sm-2">
                <img class="upi-step-num" src="../../../assets/images//payment-collection/upi-step-1.png">
            </div>
            <div class="col-xs-10 col-sm-8">
                <p class="upi-step-text class1">Enter the UPI ID and click on continue</p>
            </div>
            <div class="col-xs-0 col-sm-2">
                <img class="upi-step-next" src="../../../assets/images/payment-collection/upi-step-next.svg">
            </div>
        </div>

        <div class="col-sm-4 px-0">
            <div class="col-xs-2 col-sm-2">
                <img class="upi-step-num" src="../../../assets/images//payment-collection/upi-step-2.png">
            </div>
            <div class="col-xs-10 col-sm-8">
                <p class="upi-step-text class1">Open Bank / UPI APP on your phone</p>
            </div>
            <div class="col-xs-0 col-sm-2">
                <img class="upi-step-next" src="../../../assets/images/payment-collection/upi-step-next.svg">
            </div>
        </div>

        <div class="col-sm-4 px-0">
            <div class="col-xs-2">
                <img class="upi-step-num" src="../../../assets/images//payment-collection/upi-step-3.png">
            </div>
            <div class="col-xs-10">
                <p class="upi-step-text class2">Enter your UPI PIN to approve the pending transaction</p>
            </div>
        </div>

    </div>
</div>
